module.exports = __webpack_public_path__ + "img/session-timmer.bd2dc98f.jpg";